import {
  EDIT_USUARIO,
  FETCH_USUARIO,
  FETCH_USUARIOS,
  SET_FILTRO_USUARIOS,
  FETCH_TOKEN_RESET_PASSWORD,
  LOADING_USUARIOS,
  UPDATE_LIST_USUARIOS,
  RESET_FILTRO_USUARIO,
  RESET_USUARIO,
  FETCH_TIPOS_USUARIOS,
  FETCH_ACCIONES_TIPO_USUARIO,
  FETCH_ACCIONES,
} from './types';
import {
  postSearchUsuarioApi,
  obtenerUsuariosDeSeller,
  requestTokenResetPassword,
  getTiposUsuarios,
  getAccionesPredefinidasTipoUsuarioApi,
  getAccionesApi
} from '../api/axios';

export const userTypeIds = {
  isCategory: 1,
  isAdminMod: 2,
  isSellerAdmin: 3,
  isSeller: 4,
  isResetPassword: 5,
  isSoloLectura: 6,
  isProveedor: 7,
  isContaduria: 8,
  isTesoreria: 9,
}

const parseBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "si", "sí", "yes", "activo", "habilitado"].includes(normalized)) return true;
    if (["false", "0", "no", "inactivo", "deshabilitado"].includes(normalized)) return false;
  }
  return undefined;
};

export const getUserTypes = (tipoUsuario) => {
  return Object.keys(userTypeIds).reduce((previous, userType) => ({
    ...previous,
    [userType]: userTypeIds[userType] == tipoUsuario,
  }), {})
};

export const editUsuario = (usuario) => dispatch => {
  dispatch({
    type: EDIT_USUARIO,
    payload: usuario
  });
};

export const setFiltroUsuarios = (params) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: SET_FILTRO_USUARIOS,
      payload: params
    });
    resolve();
  });
};

export const resetFiltroUsuario = () => dispatch => {
  dispatch({
    type: RESET_FILTRO_USUARIO,
    payload: []
  });
};

export const resetUsuario = () => dispatch => {
  dispatch({
    type: RESET_USUARIO,
    payload: []
  });
};



export const fetchTokenResetPassword = (params) => async (dispatch) => {
  try {
    const payload = await requestTokenResetPassword(params);
    dispatch({
      type: FETCH_TOKEN_RESET_PASSWORD,
      token: payload,
    });
    return payload;
  } catch (error) {
      console.error("Error obteniendo el token para cambiar la contraseña");
    throw error;
  }
};


export const fetchUsuarios = (params) => async dispatch => {
  dispatch({
    type: LOADING_USUARIOS,
    payload: true
  });

  let usuarios;
  obtenerUsuariosDeSeller(params).then(function (value) {
    const normalizedValue = {
      ...value,
      elementos: value?.elementos ?? value?.Elementos ?? value?.content ?? [],
      cantidadTotal: value?.cantidadTotal ?? value?.CantidadTotal ?? value?.total ?? value?.Total ?? 0,
      cantidadPagina: value?.cantidadPagina ?? value?.CantidadPagina ?? value?.totalPages ?? value?.TotalPages ?? 0,
    };

    const { elementos, cantidadTotal, cantidadPagina } = normalizedValue;
    const normalizedUsuarios = (Array.isArray(elementos) ? elementos : []).map((item) => {
      const bajaFromPayload = parseBoolean(item?.baja ?? item?.Baja);
      const activoFromPayload = parseBoolean(item?.activo ?? item?.Activo);
      const estadoFromPayload = (item?.estado ?? item?.Estado ?? item?.situacion ?? item?.Situacion ?? "").toString().trim().toLowerCase();
      const estadoIndicaInactivo = estadoFromPayload === "inactivo";
      const rawIdEstado = item?.idEstado ?? item?.IdEstado ?? item?.estadoId ?? item?.EstadoId ?? item?.idSituacion ?? item?.IdSituacion;
      const idEstado = Number(rawIdEstado);
      const idEstadoIndicaInactivo = Number.isFinite(idEstado) && idEstado > 1;
      const baja = typeof bajaFromPayload === "boolean"
        ? bajaFromPayload
        : (typeof activoFromPayload === "boolean"
          ? !activoFromPayload
          : (estadoIndicaInactivo || idEstadoIndicaInactivo));

      return {
        ...item,
        baja,
        activo: !baja
      };
    });

    usuarios = normalizedUsuarios;
    usuarios["cantidadTotal"] = cantidadTotal;
    usuarios["cantidadPagina"] = cantidadPagina;

    dispatch({
      type: FETCH_USUARIOS,
      payload: usuarios
    });

    dispatch({
      type: LOADING_USUARIOS,
      payload: false
    });
  });
};

export const fetchUsuario = (data) => async dispatch => {
  postSearchUsuarioApi(data).then(function (value) {
    const normalizedUser = {
      ...value,
      usuario: value?.usuario ?? value?.Usuario ?? (value?.idUsuario ? value : [])
    };;
    dispatch({
      type: FETCH_USUARIO,
      payload: normalizedUser
    });
  }).catch(error => {
    console.warn("Error fetching usuario:", error);
    // Optionally dispatch an error state or reset user
    dispatch({
      type: FETCH_USUARIO,
      payload: {} // Ensure payload is empty so fallback works
    });
  });
};

export const postSearchUsuario = (data) => {
  return postSearchUsuarioApi(data).then(function (value) {
    const normalizedUser = {
      ...value,
      usuario: value?.usuario ?? value?.Usuario ?? (value?.idUsuario ? value : [])
    };
    return normalizedUser;
  }).catch(error => {
    console.warn("Error fetching usuario:", error);
  });
}

export const updateListUsuarios = (usuariosArray, userUpdated) => (dispatch, getState) => {
  const { cantidadTotal, cantidadPagina } = getState().usuarios;
  const nextBaja =
    typeof userUpdated?.baja === "boolean"
      ? userUpdated.baja
      : (typeof userUpdated?.activo === "boolean" ? !userUpdated.activo : undefined);

  const usuariosActualizados = usuariosArray.map((item) => {
    if (item.idUsuario === userUpdated.idUsuario) {
      return {
        ...item,
        email: userUpdated.email,
        fechaAlta: userUpdated.fechaAlta,
        fechaUltimoLogin: userUpdated.fechaUltimoLogin,
        moderador: userUpdated.moderador,
        nombreUsuario: userUpdated.usuario,
        ...(typeof nextBaja === "boolean" ? { baja: nextBaja } : {}),
      };
    }
    return item;
  });

  dispatch({
    type: UPDATE_LIST_USUARIOS,
    payload: {
      usuarios: usuariosActualizados,
      cantidadTotal,
      cantidadPagina,
    },
  });
};

export const fetchTipoUsuarios = (id = null) => async (dispatch) => {
  try {

    const response = await getTiposUsuarios(id);

    dispatch({
      type: FETCH_TIPOS_USUARIOS,
      payload: response,
    });

    return response;

  } catch (error) {
    console.error("Error cargando tipos de usuarios:", error);
    throw error;
  }
};

export const fetchAccionesTipoUsuario = (idTipoUsuario) => async dispatch => {
  try {
    const response = await getAccionesPredefinidasTipoUsuarioApi(idTipoUsuario);

    dispatch({
      type: FETCH_ACCIONES_TIPO_USUARIO,
      payload: response.data
    });

    return response.data;
  } catch (error) {
    console.error("Error cargando acciones:", error);
    throw error;
  }
};

export const fetchAcciones = (idAccion) => async dispatch => {
  try {
    const response = await getAccionesApi(idAccion);

    dispatch({
      type: FETCH_ACCIONES,
      payload: response.data
    });

    return response.data;
  } catch (error) {
    console.error("Error cargando acciones:", error);
    throw error;
  }
};
